import React from 'react';
import { Talk2ViewChat } from '@talk2view/sdk/chat';
import { wordTools } from './tools';
import { describeToolActivity, isToolDestructive, destructiveWarning } from './chatConfig';

const PARTNER_KEY = 'pk_live_45c878caa500cdf6ea1a72f3e9a4ad324df061b7ec2c70d7';
const BASE_URL = 'https://engine.talk2view.com';

/**
 * The task pane is the whole chat. `<Talk2ViewChat>` is `height: 100%`, and
 * `#root` is given a definite height in taskpane.html, so it needs no wrapper —
 * and no `100vh`, which an Office webview does not always agree with.
 *
 * The stylesheet is installed by `injectTalk2ViewChatStyles()` in index.tsx,
 * because this add-in's webpack has no CSS loader. See docs/packaged-chat.md.
 */
export function App() {
  return (
    <Talk2ViewChat
      partnerKey={PARTNER_KEY}
      baseUrl={BASE_URL}
      tools={wordTools}
      allowAnonymous
      welcome={{
        // Rendered at text-2xl: anything longer than a short line fills a
        // 320px task pane before the user has typed anything.
        heading: 'Your AI assistant in Word',
        suggestions: [
          'Draft a short intro about quarterly results',
          'Make the selected text more concise',
          'Insert a 3×2 table of names and roles',
        ],
      }}
      describeToolActivity={describeToolActivity}
      isToolDestructive={isToolDestructive}
      destructiveWarning={destructiveWarning}
    />
  );
}
